<template>
  <v-app id="ListPlaylists">
    <v-main>
      <v-card
        max-width="500"
        class="mx-auto"
      >
        <v-list two-line>
         <v-list-item-group
           v-model="playlists"
           multiple
         >
           <template v-for="(item, index) in playlists">
             <v-list-item :key="item.uuid">
               <template v-slot:default="{ active }">
                 <v-list-item-content>
                   <v-list-item-title v-text="item.name"></v-list-item-title>
                   <v-list-item-subtitle v-text="item.description.slice(0, 50) + '...'"></v-list-item-subtitle>
                 </v-list-item-content>
                 <v-list-item-action>
                   <v-list-item-action-text v-text="item.owner.display_name.slice(0,20) + '...'"></v-list-item-action-text>
                   <v-icon
                     v-if="!active"
                     color="grey lighten-1"
                   >
                     mdi-star-outline
                   </v-icon>
                     <v-icon
                     v-else
                     color="green"
                   >
                     mdi-star
                   </v-icon>
                 </v-list-item-action>
               </template>
             </v-list-item>
             <v-divider
               v-if="index + 1 < playlists .length"
               :key="index"
             ></v-divider>
           </template>
         </v-list-item-group>
        </v-list>
      </v-card>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
// import axios from 'axios'

export default {
  props: {
    source: String
  },
  data: () => ({
  }),
  computed: {
    ...mapGetters({
      user: 'getCurrentUser',
      authToken: 'getUserToken',
      playlists: 'getPlaylists',
      songs: 'getSongs'
    })
  },
  created () {
    this.$vuetify.theme.dark = true
  }
}
</script>
